import * as API from "../../utils/services/api";
import ArrowImg from "../../assets/arrow-section-2.svg";
import "./TreasuryBalance.css";
import React, { MouseEvent, useEffect, useRef, useState } from "react";
import { InteractionItem } from "chart.js/auto";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
} from "chart.js";
import {
  Chart,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
} from "react-chartjs-2";
import ReactApexChart from "react-apexcharts";
import axios from "axios";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip
);

const TreasuryBalance = () => {
  const [chartType, setChartType] = useState("Area Chart");
  const [condoData, setCondoData] = useState();
  const [combinedSeries, setCombinedSeries] = useState([]);

  const [condoCandle, setCondoCandle] = useState([]);
  const [condoAreaChart, setCondoAreaChart] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchCondoinfo = async () => {
      try {
        const resp = await API.fetchWalletData();
        if (resp) {
          setCondoData(resp);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchCondoinfo();
  }, []);

  useEffect(() => {
    const fetchCondoAreaChart = async () => {
      setLoading(true);
      try {
        const resp = await API.fetchPortfolioHistorical();
        if (resp) {
          setLoading(false);
          setCondoAreaChart(resp);

          const allKeys = Object.keys(resp);
          const referenceToken = allKeys[0];
          const timestamps = resp[referenceToken].map(([ts]) => ts);

          const totalCombined = timestamps.map((ts, index) => {
            let total = 0;
            for (let token of allKeys) {
              const tokenData = resp[token];
              const val = tokenData?.[index]?.[1];
              total += val || 0;
            }
            return {
              x: new Date(ts).toISOString(),
              y: Number(total.toFixed(2)),
            };
          });

          setCombinedSeries([
            {
              name: "Total Portfolio",
              data: totalCombined.filter((_, i) => i % 8 === 0),
            },
          ]);
        }
      } catch (error) {
        setLoading(false);
        console.log("Error:", error);
      }
    };

    fetchCondoAreaChart();
  }, []);

  const smallTokens = ["aurusx", "brickken", "polytrade"];

  const seriesNew = Object.entries({
    Aurusx: condoAreaChart?.aurus,
    Condo: condoAreaChart?.condo,
    Polytrade: condoAreaChart?.polytrade,
    Ethereum: condoAreaChart?.ether,
    Syrup: condoAreaChart?.syrup,
    Brickken: condoAreaChart?.brickken,
    Usdc: condoAreaChart?.usdc,
    "Index Coop Ethereum 2x Index": condoAreaChart?.eth2x,
  }).map(([name, dataArr]) => ({
    name,
    data:
      dataArr
        ?.filter((_, index) => index % 8 === 0)
        .map(([timestamp, value]) => {
          if (timestamp && value !== undefined && value !== null) {
            return {
              x: new Date(timestamp).toISOString(),
              y: Number(value.toFixed(2)),
            };
          }
          return null;
        })
        .filter((point) => point !== null) || [],
    yAxisIndex: smallTokens.includes(name.toLowerCase()) ? 1 : 0,
  }));
  const safeSeries = seriesNew.filter(
    (s) => Array.isArray(s.data) && s.data.length > 0
  );
  // const chartOptions = {
  //   chart: {
  //     type: "area",
  //     // stacked: true,
  //     height: 350,
  //     zoom: {
  //       enabled: true,
  //     },
  //     toolbar: {
  //       show: true,
  //     },
  //     offsetX: 10,
  //     offsetY: 10,
  //   },

  //   title: {
  //     text: "Portfolio Balance Summary",
  //     align: "left",
  //   },
  //   xaxis: {
  //     type: "datetime",
  //     labels: {
  //       format: "MMM dd HH:mm",
  //     },
  //   },
  //   yaxis: {
  //     labels: {
  //       formatter: (val) => {
  //         if (val >= 1000) {
  //           return `$${val / 1000}K`;
  //         } else if (val >= 1000000) {
  //           return `$${val / 1000000}M`;
  //         } else return `$${val}`;
  //       },
  //     },
  //   },
  //   colors: [
  //     "#FF5733",
  //     "#33B5E5",
  //     "#9CCC65",
  //     "#AB47BC",
  //     "#FFA726",
  //     "#26A69A",
  //     "#5C6BC0",
  //   ],
  //   tooltip: {
  //     shared: true,
  //     x: {
  //       format: "MMM dd, yyyy HH:mm",
  //     },
  //     y: {
  //       formatter: (val) => `$${val?.toFixed(2)}`,
  //     },
  //   },
  //   stroke: {
  //     curve: "smooth",
  //   },
  //   fill: {
  //     type: "gradient",
  //     gradient: {
  //       shadeIntensity: 1,
  //       inverseColors: false,
  //       opacityFrom: 0.45,
  //       opacityTo: 0.1,
  //       stops: [20, 100],
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  // };

  const chartOptions = {
    chart: {
      type: "area",
      height: 350,
      zoom: { enabled: true },
      toolbar: { show: true },
      offsetX: 10,
      offsetY: 10,
    },
    title: {
      text: "Portfolio Balance Summary",
      align: "left",
    },
    xaxis: {
      type: "datetime",
      labels: { format: "MMM dd HH:mm" },
    },
    yaxis: {
      labels: {
        formatter: (val) => {
          if (val >= 1_000_000) return `$${(val / 1_000_000).toFixed(1)}M`;
          if (val >= 1_000) return `$${(val / 1_000).toFixed(1)}K`;
          return `$${val}`;
        },
      },
    },
    tooltip: {
      shared: true,
      x: { format: "MMM dd, yyyy HH:mm" },
      y: { formatter: (val) => `$${val?.toFixed(2)}` },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    fill: {
      type: "solid",
      opacity: 0.85,
    },
    // colors: ["0f4a7f"],
    colors: ["#0087e0"],
    dataLabels: { enabled: false },
  };

  return (
    <>
      {" "}
      <div className="arrow-section-2-img-section"></div>
      <div className="container poetsen-one-regular mb-5 width-adjustment">
        <div className="treasuryBalance sub-header-text mt-5">
          {/* <h3>Condo Treasury Balance Over Time</h3> */}
          <p>
            The total balance includes Condo tokens. All Condo tokens held as
            part of the treasury may be viewed on-chain in the treasury wallets
            listed further below on this site.
          </p>
        </div>{" "}
      </div>{" "}
      <div className="container poetsen-one-regular treasury-bg">
        <h4 className="mb-4 mt-3">Condo Treasury Over Time</h4>
      </div>
      <div className="treasury-bg poetsen-one-regular mb-5">
        <div className="container poetsen-one-regular treasury-bg condo-info-new">
          <div className="row">
            {condoData && (
              <>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="real-time-div ">
                    {/* <div className="bg-condo-box"> </div> */}
                    <div className="real-time-data-p-left">
                      <h4
                        className="condo-info-heading"
                        style={{ color: "rgb(184, 0, 0)" }}
                      >
                        Daily Change
                      </h4>
                      <div className="dots-tokenomics"></div>
                      <div className="dots-tokenomics-2"></div>
                      <div className="dots-tokenomics-3"></div>
                      <div className="dots-tokenomics-4"></div>
                    </div>
                    <div className="real-time-data-p-right condo-info-p">
                      <p>${condoData?.price_change_24h.toFixed(2)}</p>

                      <span>Daily</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="real-time-div ">
                    {/* <div className="bg-condo-box"> </div> */}
                    <div className="real-time-data-p-left">
                      <h4
                        className="condo-info-heading"
                        style={{ color: "rgb(184, 0, 0)" }}
                      >
                        Weekly Change
                      </h4>
                      {/* <p>Updating Soon...</p> */}
                      <div className="dots-tokenomics"></div>
                      <div className="dots-tokenomics-2"></div>
                      <div className="dots-tokenomics-3"></div>
                      <div className="dots-tokenomics-4"></div>
                    </div>
                    <div className="real-time-data-p-right condo-info-p">
                      <p>${condoData?.price_change_7d.toFixed(2)}</p>{" "}
                      <span>Weekly</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="real-time-div ">
                    {/* <div className="bg-condo-box"> </div> */}
                    <div className="real-time-data-p-left">
                      <h4
                        className="condo-info-heading"
                        style={{ color: "rgb(184, 0, 0)" }}
                      >
                        Monthly Change
                      </h4>
                      {/* <p>Updating Soon...</p> */}
                      <div className="dots-tokenomics"></div>
                      <div className="dots-tokenomics-2"></div>
                      <div className="dots-tokenomics-3"></div>
                      <div className="dots-tokenomics-4"></div>
                    </div>
                    <div className="real-time-data-p-right condo-info-p">
                      <p>${condoData?.price_change_30d.toFixed(2)}</p>{" "}
                      <span>Monthly</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div className="real-time-div ">
                    {/* <div className="bg-condo-box"> </div> */}
                    <div className="real-time-data-p-left">
                      <h4
                        className="condo-info-heading"
                        style={{ color: "rgb(184, 0, 0)" }}
                      >
                        Market Cap Daily
                      </h4>
                      {/* <p>Coming Soon...</p> */}
                      <div className="dots-tokenomics"></div>
                      <div className="dots-tokenomics-2"></div>
                      <div className="dots-tokenomics-3"></div>
                      <div className="dots-tokenomics-4"></div>
                    </div>
                    <div className="real-time-data-p-right condo-info-p">
                      <p>${condoData?.market_cap_change_24h.toFixed(2)}</p>{" "}
                      <span>Market Cap</span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="container mt-4">
          <div className="row">
            <div className="col-lg-12">
              <div className="treasurybalancechart condo-data-new-chart">
                {chartType === "Area Chart" &&
                  (loading ? (
                    <div className="loading-table">
                      <p>Please wait, the chart is loading...</p>
                      <div className="treasury-over-loading">
                        <div className="spinner-grow" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="spinner-grow" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="spinner-grow" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    combinedSeries.length > 0 && (
                      <ReactApexChart
                        options={{
                          ...chartOptions,
                          // colors: ["#0087e0"],
                          colors: ["#0f4a7f"],
                          title: { text: "Total Portfolio Over Time" },
                        }}
                        series={combinedSeries}
                        type="area"
                        height={350}
                      />
                    )
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TreasuryBalance;
